import React, { useMemo, useState } from "react";
import FormField from "../form-field/FormField";
import { EmailValidatorModel } from "../../services/form/validators/email/EmailValidator";

interface EditEmailProps {
  email: string;
  isRequired?: boolean;
  readonly?: boolean;
}

export default function EditEmail(props: EditEmailProps) {
  const isRequired = useMemo(() => {
    if (props.isRequired === undefined) return true;
    return props.isRequired;
  }, [props.isRequired]);

  const [emailValidator] = useState(() =>
    EmailValidatorModel.create({
      isRequired: isRequired,
    })
  );
  return (
    <FormField
      id="email"
      labelKey="general.email"
      required={isRequired}
      className="input"
      fieldName="email"
      fieldValue={props.email}
      validator={emailValidator}
      placeholderKey="general.email"
      errorName="email"
      readOnly={props.readonly}
    />
  );
}
